module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "pid": "parentId",
      "cid": "id",
      "mainColumn": "name",
      "longColumn": "name",
      "resource": "rbac/menu",
      "title": "菜单管理",
      "label": "菜单",
      "labelName": "name",
      "isTree": true,
      "operation": _vm.operation,
      "operationWidth": 240,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "orderByInit": _vm.orderByInit,
      "createList": _vm.createList,
      "updateList": _vm.updateList,
      "createFormValues": _vm.createFormValues,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2301487c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/Menu.vue
// module id = 1717
// module chunks = 1